export var defaultProps = {
    className: '',
    disabled: false,
    value: '',
    defaultChecked: false,
    name: 'radio',
    marquee: 'font',
};
export var defaultGroupProps = {
    className: '',
    name: 'radioGroup',
    onChange: function (value, e) { },
};
